import { ReactNode, useEffect } from "react";
import { Subgraph, useBackfillStore } from "../../store/backfillsStore";
import { CommonDiagram } from "./CommonDiagram";

type IStaticDiagram = {
  currentSubgraph?: Subgraph;
  fullWidth?: boolean;
  fullScreenButton?: ReactNode;
  showIcons?: boolean;
};

const StaticDiagram = ({ currentSubgraph, fullWidth, fullScreenButton, showIcons }: IStaticDiagram) => {
  const currentSubgraphStore = useBackfillStore((state) => state.currentSubgraph);
  const subgraph = currentSubgraph ? currentSubgraph : currentSubgraphStore;
  const setCurrentSubgraph = useBackfillStore((state) => state.setCurrentSubgraph);
  useEffect(() => {
    setCurrentSubgraph(subgraph);
  }, [subgraph, setCurrentSubgraph]);

  return (
    <CommonDiagram
      fullScreenButton={fullScreenButton}
      fullWidth={fullWidth}
      showIcons={Boolean(showIcons)}
      type="static"
    />
  );
};

export { StaticDiagram };
